import {ValidatorBase} from "./ValidatorBase";
import {ReactUtilities} from "../react/ReactUtilities";

export class PropertyValidator<T> extends ValidatorBase{
    constructor(public prop:T,public propertyTrigger:keyof T,public executer:()=>boolean,errorMessage:string)
    {
        super();
        this.ErrorMessage=errorMessage;
    }

    Execute(): boolean {
        if(ReactUtilities.GetPropertyValue(this.prop,this.propertyTrigger,false))
        {
            return this.executer();
        }

        return true;
    }
}
